export default __webpack_public_path__ + "static/media/Icon-zoom.4eeaed6e.svg";